var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_vm._v("This site is under construction, please come back later")])}
var staticRenderFns = []

export { render, staticRenderFns }